import { useQuery } from '@tanstack/react-query';
import { getProductConditions } from '../service/getProductConditions';
import { ProductConditionResult } from '../interface/interface';

export const useGetProductConditionsQuery = (token?: string) => {
  const {
    data: conditions,
    error: isError,
    isLoading: isConditionLoading,
  } = useQuery({
    queryKey: ['productCondition', token],
    queryFn: ({ queryKey }) => {
      const [, token] = queryKey;
      return getProductConditions(token as string);
    },
    enabled: !!token,
  });

  const condition = conditions
    ?.filter((e: ProductConditionResult) => Boolean(e?.condition))
    ?.map((e: any) => ({
      label: e.condition,
      value: e.condition,
    }));

  return { condition, isError, isConditionLoading };
};
